/*-- Routing --*/
import { Route, Switch, Redirect } from 'react-router-dom';

/* API */
import { useAuth0 } from '@auth0/auth0-react';

/* Redux */
import { useSelector } from 'react-redux';

/*-- Pages --*/
import OnboardingContact from 'components/forms/OnboardingContact';
import OnboardingEducation from 'components/forms/OnboardingEducation';
import OnboardingWork from 'components/forms/OnboardingWork';
import OnboardingMilitaryExperience from 'components/forms/OnboardingMilitaryExperience';
import OnboardingEligibility from 'components/forms/OnboardingEligibility';
import OnboardingGoals from 'components/forms/OnboardingGoals';
import OnboardingLocation from 'components/forms/OnboardingLocation';
import OnboardingUIClaimant from 'components/forms/OnboardingUIClaimant';

/*-- Styles --*/
import styles from 'styles/login.module.scss';

const OnboardingPagesSwitch = () => {
  const { user } = useAuth0();
  const { needsContactInfo, needsOnboarding, urlPrefix, onboardingStep } = useSelector((state) => state.app);

  return (
    <article className={styles.loginFlow}>
      <div className={styles.loginFlow__formContainer}>{render(needsContactInfo, needsOnboarding)}</div>
    </article>
  );

  function render(needsContactInfo, needsOnboarding) {
    if (needsContactInfo) {
      // New user — only contact-info route, redirect everything else to contact-info
      return (
        <Switch>
          <Route path={['/onboarding/contact-info', '/:lang/onboarding/contact-info']}>
            <div className={styles.loginFlow}>
              <div className={styles.loginFlow__formContainer}>
                <OnboardingContact user={user} />
              </div>
            </div>
          </Route>
          <Route>
            <Redirect to={`${urlPrefix}/onboarding/contact-info`} />
          </Route>
        </Switch>
      );
    } else if (needsOnboarding) {
      // Contact info done — all onboarding routes available
      return (
        <div className={styles.loginFlow}>
          <div className={styles.loginFlow__formContainer}>
            <Switch>
              <Route path={['/onboarding/contact-info', '/:lang/onboarding/contact-info']}>
                <OnboardingContact user={user} />
              </Route>
              <Route path={['/onboarding/eligibility', '/:lang/onboarding/eligibility']}>
                <OnboardingEligibility />
              </Route>
              <Route path={['/onboarding/work-experience', '/:lang/onboarding/work-experience']}>
                <OnboardingWork />
              </Route>
              <Route path={['/onboarding/military-experience', '/:lang/onboarding/military-experience']}>
                <OnboardingMilitaryExperience />
              </Route>
              {/* Legacy route — redirect any old bookmark or history entry to the current flow */}
              <Route path={['/onboarding/experience', '/:lang/onboarding/experience']}>
                <Redirect to={`${urlPrefix}/onboarding/eligibility`} />
              </Route>
              <Route path={['/onboarding/education', '/:lang/onboarding/education']}>
                <OnboardingEducation />
              </Route>
              <Route path={['/onboarding/location', '/:lang/onboarding/location']}>
                <OnboardingLocation />
              </Route>
              <Route path={['/onboarding/ui-claimant', '/:lang/onboarding/ui-claimant']}>
                <OnboardingUIClaimant />
              </Route>
              <Route path={['/onboarding/goals', '/:lang/onboarding/goals']}>
                <OnboardingGoals />
              </Route>
              <Route>
                <Redirect to={`${urlPrefix}/onboarding/${onboardingStep}`} />
              </Route>
            </Switch>
          </div>
        </div>
      );
    }
  }
};

export default OnboardingPagesSwitch;
